/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercIal BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-10-19 15:29:32
 *
 *******************************************************/
// @flow
import expandVertical from 'src/assets/images/filter-layout/vertical/expand.png';
import leftSideVertical from 'src/assets/images/filter-layout/vertical/leftSide.png';
import offCanvasVertical from 'src/assets/images/filter-layout/vertical/offCanvas.png';
import expandVerticalGif from 'src/assets/images/filter-layout/vertical/expand.gif';
import offCanvasVerticalGif from 'src/assets/images/filter-layout/vertical/offCanvas.gif';

import expandHorizontal from 'src/assets/images/filter-layout/horizontal/expand.png';
import oneColumnHorizontal from 'src/assets/images/filter-layout/horizontal/oneColumn.png';
import twoColumnsHorizontal from 'src/assets/images/filter-layout/horizontal/twoColumns.png';
import threeColumnsHorizontal from 'src/assets/images/filter-layout/horizontal/threeColumns.png';
import expandHorizontalGif from 'src/assets/images/filter-layout/horizontal/expand.gif';
import oneColumnHorizontalGif from 'src/assets/images/filter-layout/horizontal/oneColumn.gif';
import twoColumnsHorizontalGif from 'src/assets/images/filter-layout/horizontal/twoColumns.gif';
import threeColumnsHorizontalGif from 'src/assets/images/filter-layout/horizontal/threeColumns.gif';

import defaultOffCanvasMobile from 'src/assets/images/filter-layout/mobile/default-offCanvas.png';
import expandMobile from 'src/assets/images/filter-layout/mobile/expand.png';
import fullwidthMobile from 'src/assets/images/filter-layout/mobile/fullwidth.png';
import scrollDownFullWidthMobile from 'src/assets/images/filter-layout/mobile/scrollDown-fullWidth.png';
import scrollDownOffCanvasMobile from 'src/assets/images/filter-layout/mobile/scrollDown-offCanvas.png';
import defaultOffCanvasMobileGif from 'src/assets/images/filter-layout/mobile/default-offCanvas.gif';
import expandMobileGif from 'src/assets/images/filter-layout/mobile/expand.gif';
import fullwidthMobileGif from 'src/assets/images/filter-layout/mobile/fullwidth.gif';
import scrollDownFullWidthMobileGif from 'src/assets/images/filter-layout/mobile/scrollDown-fullWidth.gif';
import scrollDownOffCanvasMobileGif from 'src/assets/images/filter-layout/mobile/scrollDown-offCanvas.gif';

export const DEFAULT_FILTER_LAYOUT_SETTINGS = {
  filterLayout: 'vertical',
  filterTreeVerticalStyle: 'style-default',
  filterTreeHorizontalStyle: 'style1',
  filterTreeMobileStyle: 'style2',
  stickyFilterOnDesktop: false,
  stickyFilterOnMobile: false
};

export const FILTER_VERTICAL_LAYOUTS = [
  {
    id: 'style-default',
    label: 'AdminHTML.FilterLayout.Constant.verticalLayout_Label1',
    imageSrc: leftSideVertical,
    imageGifSrc: leftSideVertical
  },
  {
    id: 'style-off-canvas',
    label: 'AdminHTML.FilterLayout.Constant.verticalLayout_Label2',
    imageSrc: offCanvasVertical,
    imageGifSrc: offCanvasVerticalGif
  },
  {
    id: 'style-expand',
    label: 'AdminHTML.FilterLayout.Constant.verticalLayout_Label3',
    imageSrc: expandVertical,
    imageGifSrc: expandVerticalGif
  }
];

export const FILTER_HORIZONTAL_LAYOUTS = [
  {
    id: 'style1',
    label: 'AdminHTML.FilterLayout.Constant.horizontalLayout_Label1',
    tooltip: '',
    imageSrc: oneColumnHorizontal,
    imageGifSrc: oneColumnHorizontalGif
  },
  {
    id: 'style2',
    label: 'AdminHTML.FilterLayout.Constant.horizontalLayout_Label2',
    tooltip: '',
    imageSrc: twoColumnsHorizontal,
    imageGifSrc: twoColumnsHorizontalGif
  },
  {
    id: 'style3',
    label: 'AdminHTML.FilterLayout.Constant.horizontalLayout_Label3',
    tooltip: '',
    imageSrc: threeColumnsHorizontal,
    imageGifSrc: threeColumnsHorizontalGif
  },
  {
    id: 'style-expand',
    label: 'AdminHTML.FilterLayout.Constant.horizontalLayout_Label4',
    tooltip: 'AdminHTML.FilterLayout.Constant.horizontalLayout_Label4_Tooltip',
    imageSrc: expandHorizontal,
    imageGifSrc: expandHorizontalGif
  }
];

export const DESKTOP_LAYOUTS = [
  {
    id: 'vertical_style-default',
    label: 'AdminHTML.FilterLayout.Constant.verticalLayout_Label1',
    imageSrc: leftSideVertical,
    imageGifSrc: leftSideVertical
  },
  {
    id: 'vertical_style-off-canvas',
    label: 'AdminHTML.FilterLayout.Constant.verticalLayout_Label2',
    imageSrc: offCanvasVertical,
    imageGifSrc: offCanvasVerticalGif
  },
  {
    id: 'vertical_style-expand',
    label: 'AdminHTML.FilterLayout.Constant.verticalLayout_Label3',
    imageSrc: expandVertical,
    imageGifSrc: expandVerticalGif
  },
  {
    id: 'horizontal_style1',
    label: 'AdminHTML.FilterLayout.Constant.horizontalLayout_Label1',
    tooltip: '',
    imageSrc: oneColumnHorizontal,
    imageGifSrc: oneColumnHorizontalGif
  },
  {
    id: 'horizontal_style2',
    label: 'AdminHTML.FilterLayout.Constant.horizontalLayout_Label2',
    tooltip: '',
    imageSrc: twoColumnsHorizontal,
    imageGifSrc: twoColumnsHorizontalGif
  },
  {
    id: 'horizontal_style3',
    label: 'AdminHTML.FilterLayout.Constant.horizontalLayout_Label3',
    tooltip: '',
    imageSrc: threeColumnsHorizontal,
    imageGifSrc: threeColumnsHorizontalGif
  },
  {
    id: 'horizontal_style-expand',
    label: 'AdminHTML.FilterLayout.Constant.horizontalLayout_Label4',
    tooltip: 'AdminHTML.FilterLayout.Constant.horizontalLayout_Label4_Tooltip',
    imageSrc: expandHorizontal,
    imageGifSrc: expandHorizontalGif
  }
];

export const FILTER_MOBILE_LAYOUTS = [
  {
    id: 'style2',
    label: 'AdminHTML.FilterLayout.Constant.mobileLayout_Label1',
    imageSrc: defaultOffCanvasMobile,
    imageGifSrc: defaultOffCanvasMobileGif
  },
  {
    id: 'style2-fullwidth',
    label: 'AdminHTML.FilterLayout.Constant.mobileLayout_Label2',
    imageSrc: fullwidthMobile,
    imageGifSrc: fullwidthMobileGif
  },
  {
    id: 'style1',
    label: 'AdminHTML.FilterLayout.Constant.mobileLayout_Label3',
    imageSrc: expandMobile,
    imageGifSrc: expandMobileGif
  },
  {
    id: 'style3',
    label: 'AdminHTML.FilterLayout.Constant.mobileLayout_Label4',
    imageSrc: scrollDownOffCanvasMobile,
    imageGifSrc: scrollDownOffCanvasMobileGif
  },
  {
    id: 'style3-fullwidth',
    label: 'AdminHTML.FilterLayout.Constant.mobileLayout_Label5',
    imageSrc: scrollDownFullWidthMobile,
    imageGifSrc: scrollDownFullWidthMobileGif
  }
];

export const FILTER_HORIZONTAL_LAYOUTS_EXPAND_OPTIONS_PER_ROW = [
  {
    value: '3',
    label: 'AdminHTML.FilterLayout.Constant.horizontalLayout_ExpandOptionsPerRow_Label1'
  },
  {
    value: '4',
    label: 'AdminHTML.FilterLayout.Constant.horizontalLayout_ExpandOptionsPerRow_Label2'
  },
  {
    value: '4',
    label: 'AdminHTML.FilterLayout.Constant.horizontalLayout_ExpandOptionsPerRow_Label3'
  }
];

export const FILTER_HORIZONTAL_LAYOUTS_EXPAND_COLUMNS_IN_OPTION = [
  {
    value: '1',
    label: 'AdminHTML.FilterLayout.Constant.horizontalLayout_ExpandColumnsInOption_Label1'
  },
  {
    value: '2',
    label: 'AdminHTML.FilterLayout.Constant.horizontalLayout_ExpandColumnsInOption_Label2'
  }
];
